"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
// !!! end
var Iris = require("iris");
// load data from the backend-API and fill the store with it
function fetchCabinCategories(store, args) {
    return __awaiter(this, void 0, void 0, function () {
        var premiumSupport, key, cabinCategories, priceModelArray, params, cruiseResponse, availableCabinCategoriesForPriceModel, premiumCategories, varioAICategories, varioAIAvailable, premiumCopy, _i, premiumCopy_1, premiumCat, itemCopy, mainCat, premiumItem, itemCopy, _a, premiumCategories_1, premiumCat, cc, _b, premiumCategories_2, premiumCat, cabinCatP, e_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    premiumSupport = args.premiumSupport;
                    args = lodash_1.cloneDeep(args);
                    delete args['premiumSupport'];
                    key = JSON.stringify(args);
                    store.commit('SET_LOADING_CABIN_CATEGORIES', key);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 5, , 6]);
                    cabinCategories = null;
                    priceModelArray = [args.priceModel];
                    if (args.priceModel === 'VARIO') {
                        priceModelArray.push('VARIOAI');
                    }
                    if (args.priceModel === 'VARIOAI') {
                        priceModelArray.push('VARIO');
                    }
                    if (args.priceModel === 'PREMIUM' || args.priceModel === 'PREMIUMAI') {
                        priceModelArray.push('VARIO', 'VARIOAI');
                    }
                    else if (premiumSupport) {
                        priceModelArray.push('PREMIUM', 'PREMIUMAI');
                    }
                    params = {
                        adults: args.adults,
                        juveniles: args.juveniles,
                        children: args.children,
                        priceModels: priceModelArray,
                        context: args.context,
                    };
                    return [4 /*yield*/, Iris.client.cruise(args.cruiseId, params)];
                case 2:
                    cruiseResponse = _c.sent();
                    availableCabinCategoriesForPriceModel = lodash_1.filter(cruiseResponse.cabinCategories, { available: true });
                    store.commit("SET_AVAILABLE_CABIN_CATEGORIES", availableCabinCategoriesForPriceModel);
                    premiumCategories = lodash_1.filter(cruiseResponse.cabinCategories, function (cabinCategory) {
                        return (cabinCategory.priceModel === 'PREMIUM' ||
                            cabinCategory.priceModel === 'PREMIUMAI');
                    });
                    varioAICategories = lodash_1.filter(cruiseResponse.cabinCategories, function (cabinCategorie) {
                        return cabinCategorie.priceModel === 'VARIOAI';
                    });
                    varioAIAvailable = !!lodash_1.find(varioAICategories, 'available', true);
                    // TODO: This logic could be broken if only VARIOAI is available 
                    cabinCategories = lodash_1.filter(cruiseResponse.cabinCategories, {
                        priceModel: args.priceModel === 'PREMIUM' || args.priceModel === 'PREMIUMAI' || args.priceModel === 'VARIOAI'
                            ? 'VARIO'
                            : args.priceModel,
                    });
                    // save decks
                    if (cruiseResponse && premiumSupport) {
                        // console.log('cruiseResponse', JSON.stringify(cruiseResponse.ships[0].decks))
                        store.commit('SET_DECKS', cruiseResponse.ships[0].decks);
                    }
                    store.commit('SET_MAIN_CABIN_CATEGORIES', cruiseResponse.ships[0].mainCabinCategories);
                    if (premiumCategories.length > 0) {
                        premiumCopy = lodash_1.cloneDeep(premiumCategories);
                        for (_i = 0, premiumCopy_1 = premiumCopy; _i < premiumCopy_1.length; _i++) {
                            premiumCat = premiumCopy_1[_i];
                            if (!lodash_1.find(cabinCategories, ['mainID', premiumCat.mainID])) {
                                itemCopy = lodash_1.cloneDeep(premiumCat);
                                itemCopy.available = false;
                                itemCopy.occupancy.max = 0;
                                itemCopy.occupancy.min = 0;
                                itemCopy.price = 0;
                                itemCopy.id = (itemCopy.mainID + 'V');
                                itemCopy.priceModel = 'VARIO';
                                itemCopy.surcharges = [];
                                if (!itemCopy.name) {
                                    itemCopy['name'] = itemCopy.mainName;
                                }
                                delete itemCopy['head'];
                                cabinCategories.push(itemCopy);
                            }
                        }
                        mainCat = lodash_1.find(store.getters['mainCabinCategories'], ['id', 'K']);
                        if (mainCat && !lodash_1.find(cabinCategories, ['mainID', 'K'])) {
                            premiumItem = lodash_1.find(premiumCopy, ['mainID', 'V']);
                            if (premiumItem) {
                                itemCopy = lodash_1.cloneDeep(premiumItem);
                                itemCopy.available = false;
                                itemCopy.occupancy.max = 0;
                                itemCopy.occupancy.min = 0;
                                itemCopy.price = 0;
                                itemCopy.id = 'KV';
                                itemCopy.mainID = 'K';
                                itemCopy.priceModel = 'VARIO';
                                itemCopy.surcharges = [];
                                itemCopy.image = mainCat.image;
                                itemCopy.name = mainCat.name;
                                itemCopy.mainName = mainCat.name;
                                itemCopy.mainDescription = mainCat.description;
                                delete itemCopy['head'];
                                cabinCategories.push(itemCopy);
                            }
                        }
                        // console.log('cabinCategories', JSON.stringify(cabinCategories))
                    }
                    if (!(store.getters['lastFindCabinCategoriesRequest'] === key)) return [3 /*break*/, 4];
                    cabinCategories = lodash_1.cloneDeep(cabinCategories);
                    // TODO: HACK! Adding Lanai VL (L) to premiums of Panorama P
                    if (lodash_1.find(cabinCategories, ['mainID', 'P']) &&
                        lodash_1.find(premiumCategories, ['mainID', 'L'])) {
                        for (_a = 0, premiumCategories_1 = premiumCategories; _a < premiumCategories_1.length; _a++) {
                            premiumCat = premiumCategories_1[_a];
                            if (premiumCat.mainID === 'L') {
                                premiumCat.mainID = 'P';
                            }
                        }
                    }
                    // TODO: HACK! Adding Lanai VA, VB, VC, VD, VE, VF to premiums of Veranda Komfort - much more pain edition
                    if (lodash_1.find(cabinCategories, ['mainID', 'V']) &&
                        lodash_1.find(cabinCategories, ['mainID', 'K']) &&
                        lodash_1.find(premiumCategories, ['mainID', 'V'])) {
                        cc = lodash_1.find(cabinCategories, ['mainID', 'K']);
                        for (_b = 0, premiumCategories_2 = premiumCategories; _b < premiumCategories_2.length; _b++) {
                            premiumCat = premiumCategories_2[_b];
                            if (premiumCat.mainID === 'V' &&
                                (premiumCat.id === 'VA' ||
                                    premiumCat.id === 'VB' ||
                                    premiumCat.id === 'VC' ||
                                    premiumCat.id === 'VD' ||
                                    premiumCat.id === 'VE' ||
                                    premiumCat.id === 'VF')) {
                                premiumCat.mainID = 'K';
                                premiumCat.image = cc.image;
                            }
                        }
                    }
                    if (lodash_1.find(cabinCategories, ['mainID', 'L']) &&
                        lodash_1.find(cabinCategories, ['mainID', 'P'])) {
                        cabinCatP = lodash_1.find(cabinCategories, [
                            'mainID',
                            'P',
                        ]);
                        cabinCatP.mainName = 'Panorama-/Lanaikabine';
                    }
                    // remove suits if none should be displayed, i.e. priceModel is PAUSCHAL
                    if (args.noSuits) {
                        cabinCategories = lodash_1.filter(cabinCategories, function (cc) {
                            return cc.mainID !== 'S';
                        });
                    }
                    if (lodash_1.find(cabinCategories, ['mainID', 'L'])) {
                        cabinCategories = lodash_1.filter(cabinCategories, function (cc) {
                            return cc.mainID !== 'L';
                        });
                    }
                    store.commit('SET_CABIN_CATEGORIES', {
                        cclist: lodash_1.values(cabinCategories),
                        additionalCCList: lodash_1.values(premiumCategories),
                        varioAICategories: lodash_1.values(varioAICategories),
                        shipCode: args.shipCode,
                    });
                    return [4 /*yield*/, store.dispatch('revalidateCabinCategory')];
                case 3:
                    _c.sent();
                    store.commit('FETCH_CATEGORIES_DONE', true);
                    _c.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    e_1 = _c.sent();
                    // TODO: retry?
                    /* istanbul ignore next */
                    console.log('ajax error on iris.cruise: ', e_1);
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    });
}
// load data from the backend-API and fill the store with it
function fetchCabins(store, args) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var findOldCabins, key, cruise, configCode, cabinCategories, decks, params, cabins, e_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    findOldCabins = lodash_1.find(store.state.cabins, {
                        category: args.cabinCategory,
                    });
                    if (findOldCabins && findOldCabins.cabins && findOldCabins.cabins.length) {
                        return [2 /*return*/];
                    }
                    key = JSON.stringify(args);
                    store.commit('SET_LOADING_CABINS', key);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    cruise = store.rootGetters['booking/general/cruise'];
                    configCode = (_a = args.configCode, (_a !== null && _a !== void 0 ? _a : cruise.configCode));
                    cabinCategories = null;
                    decks = store.getters['decks'];
                    params = lodash_1.merge({}, {
                        adults: args.adults,
                        juveniles: args.juveniles,
                        children: args.children,
                        cabinCategory: args.cabinCategory,
                        cruiseID: args.cruiseId,
                        configCode: configCode,
                    });
                    return [4 /*yield*/, Iris.client.cabins(params)
                        // console.log('cabins', cabins)
                    ];
                case 2:
                    cabins = _b.sent();
                    // console.log('cabins', cabins)
                    if (!cabins || !(cabins.length > 0)) {
                        throw 'Cabins empty';
                    }
                    // only apply if this response is actually the last one that got requested
                    /* istanbul ignore else */
                    if (store.getters['lastFindCabinsRequest'] === key) {
                        store.commit('SET_CABINS', { decks: decks, cabins: cabins, args: args });
                        store.commit('SET_LOADING_CABINS', '');
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_2 = _b.sent();
                    // TODO: retry?
                    /* istanbul ignore next */
                    if (store.getters['lastFindCabinsRequest'] === key) {
                        store.commit('SET_LOADING_CABINS', '');
                    }
                    console.log('ajax error on iris.cabins: ', e_2);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function fetchWishCabin(store, args) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var key, cruise, configCode, params, cabin, personNo, params_1, cabins, shipDecks, mainCode, isPremiumSelected, isPremiumAISelected, e_3;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    key = JSON.stringify(args.cabinRequest) + args.cabinID;
                    store.commit('SET_LOADING_WISH_CABIN', key);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 11, , 12]);
                    cruise = store.rootGetters['booking/general/cruise'];
                    configCode = (_a = args.cabinRequest.configCode, (_a !== null && _a !== void 0 ? _a : cruise.configCode));
                    params = lodash_1.merge({}, {
                        adults: args.cabinRequest.adults,
                        juveniles: args.cabinRequest.juveniles,
                        children: args.cabinRequest.children,
                        id: args.cabinID,
                        cruiseID: args.cabinRequest.cruiseID,
                        configCode: configCode,
                    });
                    return [4 /*yield*/, Iris.client.cabin(params)
                        // only apply if this response is actually the last one that got requested
                        /* istanbul ignore else */
                    ];
                case 2:
                    cabin = _b.sent();
                    if (!(store.getters['lastFindWishCabinRequest'] === key)) return [3 /*break*/, 10];
                    personNo = args.cabinRequest.adults +
                        args.cabinRequest.juveniles +
                        args.cabinRequest.children;
                    if (!(cabin &&
                        cabin.maxPerson >= personNo &&
                        (cabin.minPerson === undefined || cabin.minPerson <= personNo))) return [3 /*break*/, 8];
                    params_1 = lodash_1.merge({}, {
                        adults: args.cabinRequest.adults,
                        juveniles: args.cabinRequest.juveniles,
                        children: args.cabinRequest.children,
                        cabinCategory: cabin.cabinCategory,
                        cruiseID: args.cabinRequest.cruiseID,
                        configCode: configCode,
                    });
                    return [4 /*yield*/, Iris.client.cabins(params_1)
                        // add wishCabin if not in returned cabins list
                    ];
                case 3:
                    cabins = _b.sent();
                    // add wishCabin if not in returned cabins list
                    if (!lodash_1.find(cabins, ['id', cabin.id])) {
                        cabins.push(cabin);
                    }
                    shipDecks = lodash_1.cloneDeep(store.getters['decks']);
                    // SET_CABINS with accumulated data
                    store.commit('SET_CABINS', {
                        decks: shipDecks,
                        cabins: lodash_1.cloneDeep(cabins),
                        args: __assign(__assign({}, args), { cabinCategory: cabin.cabinCategory }),
                    });
                    mainCode = cabin.mainCabinCategory;
                    if (mainCode === 'L') {
                        mainCode = 'P';
                    }
                    if (cabin.cabinCategory === 'VA' ||
                        cabin.cabinCategory === 'VB' ||
                        cabin.cabinCategory === 'VC' ||
                        cabin.cabinCategory === 'VD' ||
                        cabin.cabinCategory === 'VE' ||
                        cabin.cabinCategory === 'VF') {
                        mainCode = 'K';
                    }
                    isPremiumSelected = store.getters['isPremiumSelected'];
                    if (!isPremiumSelected) return [3 /*break*/, 5];
                    return [4 /*yield*/, store.dispatch('selectMainPremiumCabinCategory', mainCode)];
                case 4:
                    _b.sent();
                    _b.label = 5;
                case 5:
                    isPremiumAISelected = store.getters['isPremiumAISelected'];
                    if (!isPremiumAISelected) return [3 /*break*/, 7];
                    return [4 /*yield*/, store.dispatch('selectMainPremiumAICabinCategory', mainCode)];
                case 6:
                    _b.sent();
                    _b.label = 7;
                case 7:
                    store.commit('SET_PREMIUM_CABIN_CATEGORY', cabin.cabinCategory);
                    store.commit('SET_PREMIUM_CABIN_SHIP_SECTION', cabin.position);
                    store.commit('SET_PREMIUM_CABIN_DECK', cabin.deck);
                    store.commit('SET_PREMIUM_CABIN_CABIN', cabin.id);
                    store.commit('SET_PREMIUM_CABIN_STEP', 'CS');
                    store.commit('SET_LOADING_REQUIRED_CABIN_INFO', {
                        message: null,
                        cabinNumber: null,
                        lastFoundCabinNumberForScrollingIntoView: args.cabinID,
                    });
                    return [3 /*break*/, 9];
                case 8:
                    if (cabin.code === '3203' ||
                        cabin.code === '3350') {
                        store.commit('SET_LOADING_REQUIRED_CABIN_INFO', {
                            message: 'Die Kabine ist nicht verfügbar',
                            cabinNumber: args.cabinID,
                            lastFoundCabinNumberForScrollingIntoView: args.cabinID,
                        });
                        //create error if maxOcc of cabin is below Pax number
                        /* istanbul ignore else */
                    }
                    else if (cabin &&
                        (cabin.minPerson > personNo || cabin.maxPerson < personNo)) {
                        store.commit('SET_LOADING_REQUIRED_CABIN_INFO', {
                            message: {
                                type: 'validation',
                                header: 'Kabine ist für die Anzahl an Personen nicht verfügbar',
                                reference: 'cabin',
                                message: 'Bitte überprüfen Sie ihre Eingabe',
                                level: 'warning',
                            },
                            cabinNumber: args.cabinID,
                        });
                    }
                    _b.label = 9;
                case 9:
                    store.commit('SET_LOADING_WISH_CABIN', '');
                    _b.label = 10;
                case 10: return [3 /*break*/, 12];
                case 11:
                    e_3 = _b.sent();
                    // TODO: retry?
                    /* istanbul ignore next */
                    if (store.getters['lastFindWishCabinRequest'] === key) {
                        store.commit('SET_LOADING_CABINS', '');
                    }
                    console.log('ajax error on findCabins: ', e_3);
                    return [3 /*break*/, 12];
                case 12: return [2 /*return*/];
            }
        });
    });
}
// resets the state object of the store
function resetStore(store) {
    store.commit('RESET_STATE');
}
// ensure that a selection is valid or none
function revalidateCabinCategory(store) {
    if (!store.getters['selectedCabinCategoryIsValid']) {
        store.commit('REMOVE_USER_SELECTIONS');
    }
}
// select the given cabinCategoryCode if possible, restricts to available cabins
function selectMainGenericCabinCategory(store, code) {
    var available = store.getters['availableMainCabinCategories'];
    var codes = lodash_1.map(available, function (cabin) {
        return cabin.mainCode;
    });
    if (lodash_1.includes(codes, code)) {
        store.commit('SELECT_MAIN_CABIN_CATEGORY', {
            code: code,
            activeAdditionalCategory: 'NONE',
        });
    }
}
function selectVarioAIMainCabinCategory(store, code) {
    var available = store.getters['availableMainCabinCategories'];
    var codes = lodash_1.map(available, function (cabin) {
        return cabin.mainCode;
    });
    if (lodash_1.includes(codes, code)) {
        store.commit('SELECT_MAIN_CABIN_CATEGORY', {
            code: code,
            activeAdditionalCategory: 'VARIOAI',
        });
    }
}
// select the given cabinCategoryCode if possible, restricts to available cabins
function selectMainPremiumCabinCategory(store, code) {
    var available = store.getters['availablePremiumCabinCategories'];
    var codes = lodash_1.map(available, function (cabin) {
        return cabin.mainCode;
    });
    if (lodash_1.includes(codes, code)) {
        store.commit('SELECT_MAIN_CABIN_CATEGORY', {
            code: code,
            activeAdditionalCategory: 'PREMIUM',
        });
    }
}
// select the given cabinCategoryCode if possible, restricts to available cabins
function selectMainPremiumAICabinCategory(store, code) {
    var available = store.getters['availablePremiumAICabinCategories'];
    var codes = lodash_1.map(available, function (cabin) {
        return cabin.mainCode;
    });
    if (lodash_1.includes(codes, code)) {
        store.commit('SELECT_MAIN_CABIN_CATEGORY', {
            code: code,
            activeAdditionalCategory: 'PREMIUMAI',
        });
    }
}
function selectPremiumCabinCategory(store, code) {
    var oldValue = store.getters['currentSelectionCategoryConfiguration'];
    if (!oldValue) {
        // no current premium category configuration means there isnt a valid main selected
        // the setters depend on the current config. so return here
        return;
    }
    //TODO: fetch Cabins
    //add checks
    if (oldValue.subCategory !== code) {
        // new category, reset old steps
        store.commit('SET_PREMIUM_CABIN_SHIP_SECTION', null);
        store.commit('SET_PREMIUM_CABIN_CABIN', null);
        store.commit('SET_PREMIUM_CABIN_DECK', null);
    }
    store.commit('SET_PREMIUM_CABIN_CATEGORY', code);
}
function checkDeckForRespectfulCabinPlacement(deck, store) {
    var availableCabins = store.getters['currentCabinsOnSection'];
    store.getters['currentCabinsOnSection'];
    var cabinsOnDeck = lodash_1.filter(availableCabins, { deck: deck });
    var otherCabins = store.getters['selectedByOtherStores'];
    var cabinsOnDeckUsedByOtherStores = 0;
    for (var _i = 0, cabinsOnDeck_1 = cabinsOnDeck; _i < cabinsOnDeck_1.length; _i++) {
        var cabin = cabinsOnDeck_1[_i];
        if (otherCabins.indexOf(cabin.id) !== -1) {
            cabinsOnDeckUsedByOtherStores = cabinsOnDeckUsedByOtherStores + 1;
        }
    }
    return cabinsOnDeck.length > cabinsOnDeckUsedByOtherStores;
}
function setShipSection(store, section) {
    var oldValue = store.getters['currentSelectionCategoryConfiguration'].shipSection;
    store.commit('SET_PREMIUM_CABIN_SHIP_SECTION', section);
    if (oldValue !== section) {
        // new ship section, reset old steps
        // set and find uppiest deck :)
        var availableDecks = lodash_1.reverse(lodash_1.sortBy(store.getters['currentAvailableDecks'], 'deck'));
        var deck = null;
        // well check first if this deck has only one cabin and whether this one is already selected
        // oh and all this checking makes no sense if there is only one deck on this section
        if (availableDecks.length > 1) {
            for (var _i = 0, availableDecks_1 = availableDecks; _i < availableDecks_1.length; _i++) {
                var availableDeck = availableDecks_1[_i];
                if (checkDeckForRespectfulCabinPlacement(availableDeck.deck, store)) {
                    deck = availableDeck.deck;
                    break;
                }
            }
        }
        if (!deck && availableDecks.length) {
            deck = availableDecks[0].deck;
        }
        store.dispatch('setDeck', deck);
    }
    store.commit('SET_PREMIUM_CABIN_STEP_NEXT');
}
function setDeck(store, deck) {
    var oldValue = store.getters['currentSelectionCategoryConfiguration'];
    store.commit('SET_PREMIUM_CABIN_DECK', deck);
    if ((oldValue.deck !== deck &&
        store.getters['currentCabinsOnDeck'] &&
        store.getters['currentCabinsOnDeck'].length) ||
        (oldValue.deck === deck &&
            deck &&
            store.getters['currentSelectionCabin'] === null)) {
        var cabins = store.getters['currentCabinsOnDeck'];
        if (cabins.length) {
            var cabinNumber = null;
            var otherCabins = store.getters['selectedByOtherStores'];
            for (var _i = 0, cabins_1 = cabins; _i < cabins_1.length; _i++) {
                var cabin = cabins_1[_i];
                if (otherCabins.indexOf(cabin.id) !== -1) {
                    continue;
                }
                cabinNumber = cabin.id;
                break;
            }
            if (!cabinNumber && cabins.length) {
                cabinNumber = cabins[0].id;
            }
            store.commit('SET_PREMIUM_CABIN_CABIN', cabinNumber);
        }
    }
}
function setCabin(store, cabin) {
    store.commit('SET_PREMIUM_CABIN_CABIN', cabin);
}
// select the cheapest available cabinCategory
function selectCheapestCabinCategory(store) {
    var cheapest = store.getters['cheapestCabinCategory'];
    var selected = store.getters['selectedCabinCategory'];
    var isPremiumSelected = store.getters['isPremiumSelected'];
    var isPremiumAISelected = store.getters['isPremiumSelected'];
    var isVarioAISelected = store.getters['isVarioAISelected'];
    var activeAdditionalCategoryState = isPremiumSelected
        ? 'PREMIUM'
        : isPremiumAISelected
            ? 'PREMIUMAI'
            : 'NONE';
    if (cheapest && (!selected || cheapest.mainCode !== selected.mainCode)) {
        store.commit('SELECT_MAIN_CABIN_CATEGORY', {
            code: cheapest.mainCode,
            activeAdditionalCategory: activeAdditionalCategoryState,
        });
    }
}
// store.getters['selectedCabinCategory'],
// update the price value of the currently selected cabinCategory
function updateSelectedCabinCategoryPrice(store, value) {
    var cabinCategory = store.getters['selectedCabinCategory'];
    if (cabinCategory) {
        store.commit('SET_CABIN_CATEGORY_PRICE', {
            category: cabinCategory,
            value: value,
        });
    }
}
function setLowCabinInfo(store, show) {
    store.commit('SET_LOW_CABIN_INFO', show);
}
// export everything compliant to the vuex specification for actions
exports.default = {
    fetchCabinCategories: fetchCabinCategories,
    revalidateCabinCategory: revalidateCabinCategory,
    selectMainGenericCabinCategory: selectMainGenericCabinCategory,
    selectVarioAIMainCabinCategory: selectVarioAIMainCabinCategory,
    selectMainPremiumAICabinCategory: selectMainPremiumAICabinCategory,
    selectMainPremiumCabinCategory: selectMainPremiumCabinCategory,
    selectCheapestCabinCategory: selectCheapestCabinCategory,
    updateSelectedCabinCategoryPrice: updateSelectedCabinCategoryPrice,
    selectPremiumCabinCategory: selectPremiumCabinCategory,
    setShipSection: setShipSection,
    setCabin: setCabin,
    fetchCabins: fetchCabins,
    setDeck: setDeck,
    fetchWishCabin: fetchWishCabin,
    resetStore: resetStore,
    setLowCabinInfo: setLowCabinInfo,
};
//# sourceMappingURL=actions.js.map